import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';


@Component({
  selector: 'app-agent-backup',
  templateUrl: './agent-backup.component.html',
  styleUrls: ['./agent-backup.component.css']
})
export class AgentBackupComponent extends BaseCrudComponent {

  translations: any;
  listUsers: any;
  listDocs: any;
  listPerms: any;
  loadingRequired: any;
  branches: any;

  listZones: any;
  listChiefs: any;
  listSupervisor: any;
  listAgents: any;

  listAgentsBackup: any;
  
  constructor(
      srv: ApiService,
      modalService: NgbModal,
      storage: Storage,
      router: Router,
      private route: ActivatedRoute,
      public translate: TranslateService
  ) {
      super(srv, modalService, storage, router);

      this.read_url = 'AgentBackup/All';
      this.create_url = 'AgentBackup/Create';
      this.update_url = 'AgentBackup/Update';
      this.delete_url = 'AgentBackup/LogicalDelete';
      this.search_fields = ['backupName', 'replaceName'];
      this.listUsers = [];
      this.listDocs = [];
      this.listPerms = [];
      this.branches = [];

      this.listChiefs = [];
      this.listSupervisor = [];
      this.listZones = [];
      this.listAgents = [];


      this.listAgents = [];
      this.listAgentsBackup = [];

      this.loadingRequired = false;

      this.reload.subscribe(val => {
          if (val) {
              super.clearData();
              this.getList();
          }
      });
  }

  ngOnInit() {
      this.translate.getTranslation(this.translate.currentLang)
          .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
          });
  }

  public getFiltersData() {
      var par_url = 'Profile/All';

      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }

  openCreateModal(content: any) {
      this.c_obj = {};
      this.c_obj.permList = [];
      this.c_obj['agent_obj'] = null;
      this.c_obj['agent_backup_obj'] = null;

      super.openCreateModal(content);
      this.loadingRequired = true;
      this.getFiltersData().subscribe(x => {
          //this.loadingRequired = false;
          if (x != false) {
              if (Array.isArray(x)) {
                  x.forEach(i => {
                      this.c_obj.permList.push(i);
                  });
              }
          }

          this.getAgentsData().subscribe(d => {
              this.loadingRequired = false;
              if (d != false) {
                  this.listAgents = d;
              }
          });

          this.getAgentsBackupData().subscribe(e => {
            this.loadingRequired = false;
            if (e != false) {
                this.listAgentsBackup = e;
            }
        });
      });
  }

  openUpdateModal(content: any, obj: any) {
      obj.permList = [];
      obj['agent_obj'] = null;
      obj['agent_backup_obj'] = null;
      super.openUpdateModal(content, obj);

      this.loadingRequired = true;
      this.getFiltersData().subscribe(x => {
          //this.loadingRequired = false;
          if (x != false) {
              if (Array.isArray(x)) {
                  x.forEach(i => {
                      this.u_obj.permList.push(i);
                  });
              }

              this.u_obj.permList.forEach(p => {
                  if (this.u_obj.userProfiles.filter(i => { return i.profileId == p.id }).length > 0) {
                      p.sel = true;
                  }
                  else {
                      p.sel = false;
                  }
              });
          }

          this.getBranchesData().subscribe(b => {
              this.loadingRequired = false;
              if (b != false) {
                  this.branches = b;
              }
          });

          this.getZonesData().subscribe(c => {
              this.loadingRequired = false;
              if (c != false) {
                  this.listZones = c;
              }
          });

          this.getAgentsData().subscribe(d => {
              this.loadingRequired = false;
              if (d != false) {
                  this.listAgents = d;

                  /*if( (obj['sapCode'] != undefined) && (obj['sapCode'] != null) ){
                      let tmp = this.listAgents.filter(r => r.agentCode == obj['sapCode']);
                      if( tmp.length > 0 ){
                          this.u_obj['agent_obj'] = tmp[0];
                          console.log(obj);
                      }
                  }*/
              }
          });

      });
  }

  validateCreateInfo(fields: any) {
      let mygroup: any = {};
      mygroup = new FormGroup({
          'backupName': new FormControl(fields.agent_backup_obj, [Validators.required]),
          'replaceName': new FormControl(fields.agent_obj, [Validators.required]),
          /*'password': new FormControl(fields.password, [Validators.required]),
          'email': new FormControl(fields.email, [Validators.required, Validators.email])*/
      });

      return mygroup.valid;
  }

  validateUpdateInfo(fields: any) {
      let mygroup: any = {};
      mygroup = new FormGroup({
          'backupName': new FormControl(fields.agent_backup_obj, [Validators.required]),
          'replaceName': new FormControl(fields.agent_obj, [Validators.required]),
      });

      return mygroup.valid;
  }

  public createItem(content: any, form: any) {
      var validated = true;

      if (form == undefined) {
          form = {};
      }
      console.log(form);
      validated = this.validateCreateInfo(form);
    

      if (!validated) {
          Swal.fire(this.translations['msg_all_required'], '', 'error');
          return;
      }

      var to: any;
      to = {};
      to.backupCode = form['agent_backup_obj']['agentCode'];
      to.replaceCode = form['agent_obj']['agentCode'];

      var qst = this.create_url;
      this.isCreating = true;

      this.srv.postCall(qst, to).subscribe(x => {
          this.isCreating = false;
          if (x.status) {
              this.c_obj = {};
              this.getList();
              this.closeModal(content);
              Swal.fire(this.translations.created, '', 'success');
          }//end success
          else {
              //Swal.fire(this.translations[x.msg], '', 'error');
              Swal.fire(x.message, '', 'error');
          }
      });
  }

  public updateItem(content: any, form: any) {
      var validated = true;

      if (form == undefined) {
          form = {};
      }

      validated = this.validateUpdateInfo(form);
      if (!validated) {
          Swal.fire(this.translations['msg_all_required'], '', 'error');
          return;
      }

      var to: any;
      to = {};
      to.id = form.id;

      to.backupCode = form['agent_backup_obj']['agentCode'];
      to.replaceCode = form['agent_obj']['agentCode'];

      //var qst = this.update_url + '/' + form.id;
      var qst = this.update_url;
      this.isUpdating = true;

      this.srv.postCall(qst, to).subscribe(x => {
          this.isUpdating = false;
          if (x.status) {
              this.getList();
              this.closeModal(content);
              Swal.fire(this.translations['updated'], '', 'success');
          }//end success
          else {
              Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
          }
      });
  }

  searchUsers = (text$: Observable<string>) =>
      text$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          map(term => term.length < 2 ? []
              : this.listUsers.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
      );

  formatterUsers = (x: any) => x.name;

  public getBranchesData() {
      var par_url = 'Subsidiary/All';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }


  public getZonesData() {
      //var par_url = 'ZoneBP/All';
      var par_url = 'Zone/All';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }

  public getSupervisorsData() {
      var par_url = 'Agent/All';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }

  public getChiefsData() {
      var par_url = 'Agent/All';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }

  public getAgentsData() {
      var par_url = 'Agent/All';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
  }

  public getAgentsBackupData() {
    var par_url = 'AgentBackup/AllBackup';
    return this.srv.getCall(par_url).pipe(
        mergeMap(x => {
            let mydata: any = { status: false, message: '', data: [] };
            mydata = x;

            if (mydata.status == true) {
                return of(mydata.data);
            }
            else {
                return of(false);
            }
        }),
        //timeout(MAX_TIME),
        catchError(data => of(false))
    );
}


}
